import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
// import { rectSortingStrategy } from "@dnd-kit/sortable";
// import { MultipleContainers } from "../sortableContainers/MultipleContainers";
import { SortableTree } from "../sortableMenu/SortableTree";
import style from './library.module.css'
import Icons from "../module.icons";
import Dropdown from '../modules/dropdown'
import axios from "axios";
// import { Rnd } from "react-rnd";
import Cookies from "js-cookie";
import gsap from "gsap";
// import { SketchPicker } from 'react-color';
import classNames from "classnames";
import { format, zonedTimeToUtc } from 'date-fns-tz';
import { apiCall } from "../narrativeUtils/fetch";

import Config from "../../Config.json";
import Loader from "../../static/svg/loader.svg";
import Modal from "../module.modal";
import MenuList from "../module.menulist";
import { UploadFile } from "./addfile";

import { getFileType, fileNameType, stripTags } from "../../utils/helpers";
// Icons
import OpenLink from "../../static/svg/openLink-w.svg";
// import { ReactComponent as Edit } from "../../static/icons/edit.svg";
// import { ReactComponent as ArrowRight } from "../../static/icons/arrow_right.svg";
import { ReactComponent as ArrowBack } from "../../static/icons/arrow_back.svg";
import { ReactComponent as Close } from "../../static/svg/close.svg";
import {ReactComponent as AllPhotos} from "../../static/icons/photo_library.svg";
// import { ReactComponent as Image } from "../../static/icons/image.svg";
// import { ReactComponent as Video } from "../../static/icons/video.svg";
// import { ReactComponent as Svg } from "../../static/icons/svg.svg";
import { ReactComponent as Delete } from "../../static/icons/delete.svg";
// import {ReactComponent as AddBox} from "../../static/icons/add_box.svg"

function Library(props) {

  const sorting = [
    {
    'id': 0,
    'label': 'Newest',
    'value': '-created'
    },
    {
      'id': 1,
      'label': 'Oldest',
      'value': 'created'
    },
    {
      'id': 2,
      'label': 'A to Z',
      'value': 'ordering_name'
    },
    {
      'id': 3,
      'label': 'Z to A',
      'value': '-ordering_name'
    }
  ]

  const navigate = useNavigate();
  let { id } = useParams();
  const storageBarRef = useRef();
  const thumbsRef = useRef();
  const [storage, setStorage] = useState(null);
  const [files, setFiles] = useState();
  const [module, setModule] = useState(null);
  const [moduleObj, setModuleObj] = useState(null);
  const [refresh, setRefresh] = useState();
  const [categories, setCategories] = useState();
  const [flatCategories, setFlatCategories] = useState();
  const [showError, setShowError] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [editField, setEditField] = useState(null);
  const [showCategoryForm, setShowCategoryForm] = useState(false);
  const [activeCategory, setActiveCategory] = useState();
  const [formError, setFormError] = useState();
  const [assignCatId, setAssignCatId] = useState();
  const [newFileId, setNewFileId] = useState();
  const [pages, setPages] = useState();
  const [sort, setSort] = useState('-created');
  const [showSort, setShowSort] = useState(false);
  const [selectFile, setSelectFile] = useState(false);
  const [showFolderDelete, setShowFolderDelete] = useState(false);
  // const [sortDown, setSortDown] = useState(true);

  function getAssets(callBack, url) {
    function responseTask(response) {
      setModule(response.data['results']);
      setFiles(response.data['results']);
      setShowLoader(false);
      console.log("library", response.data);
      setPages({count: response.data.count, next: response.data.next, previous: response.data.previous})
      if (callBack) {
        setTimeout(() => {
          callBack();
        }, 300);
        
      }
    }
    let api_url;
    if (url) {
      api_url = url;
    } else {
      // api_url = Config.originURL + "/api/cms/asset-library-index/";
      if (activeCategory) {
        api_url = Config.originURL + "/api/cms/asset-library-index/?folder=" + activeCategory + "&ordering=" + sort;
      } else {
        api_url = Config.originURL + "/api/cms/asset-library-index/?folder__isnull=true&ordering=" + sort;
      }
      
    }
    let formData = null
    apiCall("GET", api_url, formData, responseTask, null, setFormError, setShowLoader);
  }

  useEffect(() => {
    props.setTools("canvas");
    fetchJSON(null);

    props.setSmLogo(true);
    return () => {
      props.setSmLogo(false);
    };

    // login();
  }, []);

  useEffect(() => {
    if (storage && storageBarRef.current) {
      let currentStorage = storage.storage_total_mb/1024;
      const percentage = currentStorage / storage.storage_max_gb;
      const svgWidth = 251;
      const progressWidth = percentage * svgWidth;
      storageBarRef.current.setAttribute('width', progressWidth);
    }
  }, [storage])

  useEffect(() => {
    if (module || files) {
      setTimeout(() => {
        gsap.to(thumbsRef.current, {opacity: 1, duration: 0.2})
      }, 300);
     
    }
  }, [module, files])

    useEffect(() => {
  
      if (moduleObj) {
        animModalIn(moduleObj)
        // if (assignCatId) {
        //   handleModuleSave('filecategory', assignCatId)
        // }
        console.log('moduleObj loaded', moduleObj)
      }
    }, [moduleObj])

    useEffect(() => {
      if (activeCategory) {
        
        let search = "";
        function getAssets(callBack) {
          function responseTask(response) {
            setModule(response.data['results']);
            setFiles(response.data['results']);
            setShowLoader(false);
            console.log("library", response.data);
            setPages({count: response.data.count, next: response.data.next, previous: response.data.previous})
         
          }
          let api_url = Config.originURL + "/api/cms/asset-library-index/?folder=" + activeCategory;
          console.log('api_url', )
          let formData = null
          apiCall("GET", api_url, formData, responseTask, null, setFormError, setShowLoader);
        }
  
        getAssets();
        

      } else {
        getAssets()
      } 
    }, [activeCategory])


    useEffect(() => {

      if (sort) {
        function getAssets(callBack) {
          function responseTask(response) {
            if (response.data['results']) {
              setModule(response.data['results']);
              setFiles(response.data['results']);
            }
            
            setShowLoader(false);
            setPages({count: response.data.count, next: response.data.next, previous: response.data.previous})

            console.log('pages', response.data)
          }
          let api_url;
          // let api_url = Config.originURL + "/api/cms/asset-library-index/?ordering=" + sort;
          if (activeCategory) {
            api_url = Config.originURL + "/api/cms/asset-library-index/?folder=" + activeCategory + "&ordering=" + sort;
          } else {
            api_url = Config.originURL + "/api/cms/asset-library-index/?folder__isnull=true&ordering=" + sort;
          }
          let formData = null
          apiCall("GET", api_url, formData, responseTask, null, setFormError, setShowLoader);
        }

        getAssets()
      }

    }, [sort])


  function handleBackBtn() {
    navigate("/");
    setShowError(false);
  }

  function fetchJSON(callback) {

    function getStorage() {
      function responseTask(response) {
        setStorage(response.data);
        console.log("storage", response.data);
      }
      let api_url = Config.baseURL + "/api/cms/asset-library-storage/";
      let formData = null
      apiCall("GET", api_url, formData, responseTask, null, setFormError, setShowLoader);
    }

    function buildMenu() {
      function responseTask(response) {
        setCategories(response.data);
        let flat = [];
        response.data.forEach(a => {
          flat.push(a)
          a.children.forEach(b => {
            flat.push(b)
            b.children.forEach(c => {
              flat.push(c)
            })
          })
        })
        setFlatCategories(flat);

        console.log("categories", response.data);
      }
      let api_url = Config.baseURL + "/api/cms/asset-library-menu/";
      let formData = null
      apiCall("GET", api_url, formData, responseTask, null, setFormError, setShowLoader);
    }

    function getAssets(callBack, url) {
      function responseTask(response) {
        console.log('response', response.data)
         if (!callBack) setModuleObj(null)
        if (response && response.data && response.data['results']) {
           setModule(response.data['results']);
           setFiles(response.data['results']);
          
        }
       
        setShowLoader(false);
        console.log("library", response.data);
        if (callBack) {
          setTimeout(() => {
            callBack();
          }, 300);
          
        }
      }
      let api_url;
      if (url) {
        api_url = url;
      } else {
        if (activeCategory) {
          api_url = Config.originURL + "/api/cms/asset-library-index/?folder=" + activeCategory
        } else {
          api_url = Config.originURL + "/api/cms/asset-library-index/?folder__isnull=true&ordering=" + sort;
        }
      }
      let formData = null
      console.log('url', api_url)
      apiCall("GET", api_url, formData, responseTask, null, setFormError, setShowLoader);
    }

    getStorage();
    buildMenu();
    getAssets(callback);

  }

  function handleAddFile() {
    document.getElementById('uploadLibraryAsset').click();
  }

  function handleAddCategory(name) {
    setShowLoader(true);
    const api_url = Config.baseURL + "/api/cms/asset-library-menu/";
    var dataJSON = {
      'org': props.user.org && props.user.org.id,
      'name': name,
      'ordering': categories.filter(a => a.parent === null).length
    };
    axios({
      method: "POST",
      url: api_url,
      data: dataJSON,
      headers: {
        Authorization: "Token " + Cookies.get("_expo_tokenid"),
      },
    })
      .then((response) => {
       
        fetchJSON();
        setShowCategoryForm(false);
      })
      .catch((error) => {
        console.log("error", error.response);
      });
  }

  function handleUpdateCategory(field, value) {
    setShowLoader(true);
    const api_url = Config.baseURL + "/api/cms/asset-library-menu/" + activeCategory + "/";
    var dataJSON = {};
    dataJSON[field] = value;
    if (field !== 'name') {
      dataJSON['name'] = "del";
    } 
    axios({
      method: "POST",
      url: api_url,
      data: dataJSON,
      headers: {
        Authorization: "Token " + Cookies.get("_expo_tokenid"),
      },
    })
      .then((response) => {
  
        setShowFolderDelete(false);
        setShowCategoryForm(false);
        if (field === 'delete') {
          setActiveCategory(null)
        }
        // fetchJSON();
        // Workaround
        window.location.reload();
        
      })
      .catch((error) => {
        console.log("error", error.response);
      });
  }

  function handleModuleSave(field, value) {
    // setShowLoader(true)
    props.onMouseLeave();
    const api_url = Config.baseURL + "/api/cms/asset-library/" + moduleObj + "/";
    var dataJSON = {};
    // dataJSON["gallery"] = id.replace("gallery-", "");
    dataJSON[field] = value;

    console.log("handleModuleSave", dataJSON);

    function responseTask(response) {
      let updatedObj = response.data;
      if (updatedObj && updatedObj.id) {
        let mergedUpdate = {...updatedObj, [field]: value};
        setFiles(prev => prev.map(f => f.id === updatedObj.id ? {...f, ...mergedUpdate} : f));
        setModule(prev => prev.map(f => f.id === updatedObj.id ? {...f, ...mergedUpdate} : f));
        setModuleObj(updatedObj.id);
        setRefresh(Date.now());
      } else {
        setModuleObj(null);
      }
      setShowLoader(false);
    }
    apiCall(
      "POST",
      api_url,
      dataJSON,
      responseTask,
      null,
      setFormError,
      setShowLoader
    );
  }


  function handleModuleMedia(e, field) {
    const file = e.target.files[0];
    if (!file) return;

    const currentObj = files.find(f => f.id === moduleObj);
    const previousModified = currentObj && currentObj.modified;

    setShowLoader(true);

    const api_url = Config.baseURL + "/api/cms/asset-library/" + moduleObj + "/";
    var formData = new FormData();
    formData.append(field, file, file.name);

    function responseTask(response) {
      // File processing is async (Celery). Poll until modified changes.
      const assetId = moduleObj;
      const pollInterval = setInterval(() => {
        let pollUrl;
        if (activeCategory) {
          pollUrl = Config.originURL + "/api/cms/asset-library-index/?folder=" + activeCategory + "&ordering=" + sort;
        } else {
          pollUrl = Config.originURL + "/api/cms/asset-library-index/?folder__isnull=true&ordering=" + sort;
        }
        apiCall("GET", pollUrl, null, function(pollResponse) {
          let asset = pollResponse.data.results.find(f => f.id === assetId);
          if (asset && asset.modified !== previousModified) {
            clearInterval(pollInterval);
            setModule(pollResponse.data.results);
            setFiles(pollResponse.data.results);
            setPages({count: pollResponse.data.count, next: pollResponse.data.next, previous: pollResponse.data.previous});
            setShowLoader(false);
          }
        }, null, null, null);
      }, 2000);

      // Safety timeout
      setTimeout(() => {
        clearInterval(pollInterval);
        setShowLoader(false);
      }, 60000);
    }

    apiCall("POST", api_url, formData, responseTask, null, setFormError, setShowLoader);
  }

  function animModalIn(objId) {
    let target = "#moduleDetail_" + objId;
    gsap.to(target, { opacity: 1, duration: 0.2 });
  }

  function animModalOut(objId, file) {
    let target = '.moduleDetail';
    function onModalClosed() {
      setModuleObj(null);
      getAssets();
    }
    if (file) {
      gsap.to(target, {
        opacity: 0,
        duration: 0.2,
        onComplete: onModalClosed,
      });
    } else {
      // handleModuleSave("delete", true);
      setTimeout(() => {
        gsap.to(target, {
          opacity: 0,
          duration: 0.2,
          onComplete: onModalClosed,
        });
      }, 300);
    }
  }


  function handleOnKeyUp(e, field, group, objId) {
    if (group === "asset") {
      if (e.key === "Enter") {
        e.target.blur();
        setEditField(null);
      }
    }
    // if (group === "category") {
    //   if (e.key === "Enter") {
    //     handleCategorySave(field, e.target.value, objId);
    //   }
    // }
  }

  function onSearch(e){
    let search = e.target.value;
    if (e.key === "Enter") {
     
      function getAssets(callBack) {
        function responseTask(response) {
          setModule(response.data['results']);
          setFiles(response.data['results']);
          setShowLoader(false);
          console.log("library", response.data);
          setPages({count: response.data.count, next: response.data.next, previous: response.data.previous})
      
        }
        let folder = activeCategory;
        if (folder) {
          search = search + '&folder=' + folder;
        }
        let api_url = Config.originURL + "/api/cms/asset-library-index/?search=" + search;
        let formData = null
        apiCall("GET", api_url, formData, responseTask, null, setFormError, setShowLoader);
      }

      getAssets();

  

    }
  }

  function clearSearch(e) {  
    if (!e.target.value.length) {
      function getAssets(callBack) {
        function responseTask(response) {

          let allFiles = [ ...response.data['results'] ]
          let filtered = allFiles.filter(a => a.folder === activeCategory)
          setModule(filtered);

          setFiles(response.data['results']);
          setShowLoader(false);
          console.log("library", response.data);
          setPages({count: response.data.count, next: response.data.next, previous: response.data.previous})
      
        }
        let api_url = Config.originURL + "/api/cms/asset-library-index/";
        let formData = null
        apiCall("GET", api_url, formData, responseTask, null, setFormError, setShowLoader);
      }

      getAssets();
    }
  }

  // function onLayerSort(items) {
  //   console.log("onLayerSort", items);
  //   let files = [];
  //   items.forEach((a, i) => {
  //     files.push(a.id);
  //   });
  //   onFilesSort(files);
  // }

  function onLayerClick(id) {
    console.log("onLayerClick", id);
    function showThumbs() {
      // 
      setActiveCategory(id)
    }
    gsap.to(thumbsRef.current, {opacity: 0, duration: 0, onComplete: showThumbs()})
    
  }

  function onFileClick(obj) {

    if (props.isModal) {
      console.log('onFile')
      if (selectFile === obj.id) {
        setSelectFile(null);
      } else {
        setSelectFile(obj.id);
      }
      
    } else {
      console.log('onFile')
      setModuleObj(obj.id);
      setRefresh(obj.modified)
    }
    
  }

  function onMenuSort(items) {
    console.log('sort pages received', items);
    const api_url = Config.baseURLcms + "asset-library-menu-reorder/";
    let formData = {}
    formData['objs'] = items
    console.log('sending pages reorder', formData['objs'])
    function responseTask() {
      // if (i === a.children.length - 1) {
      //   props.fetchJSON(null, false)
      //   console.log('child sort finished')
      // }
      fetchJSON(null)
    }
    apiCall("POST", api_url, formData, responseTask, null, setFormError, setShowLoader)
  }

   function downloadFile(fileName) {
    // Need to update this with variable
    axios
    .get(Config.mediaURL + fileName, 
      { responseType: 'blob',
        headers: {}
      })
    .then((response) => {

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      console.log('url', response)

      const link = document.createElement('a');
      link.href = url;
      link.download = fileName.replace('library/',''); 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); 

      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error('Error downloading the file:', error);
      alert('Failed to download the file.');
    });
  }

  function onUploadAsset(e){
    let files = document.getElementById('uploadLibraryAsset').files;
    console.log('files', files)
    
    UploadFile(props.user.org && props.user.org.id, props.user, files, props.user.org.validations, fetchJSON, setShowLoader, setNewFileId, setFormError, activeCategory)
  }

  function onSelectFolder(value){
    console.log('onSelectFolder', value)

    handleModuleSave('folder', value)
  }

  function onSortBtn(){
    document.querySelector('#sortModal').classList.toggle('on');
  }

  function onSortChoice(val){
    setSort(val)
    onSortBtn()
  }

  function onUpdateFolderBtn(){
    document.querySelector('#updateFolderModal').classList.toggle('on');
  }

  function onUpdateFolder(action){
    console.log('onUpdateFolder', action)
    onUpdateFolderBtn()
    if (action === 'rename'){

      setShowCategoryForm(true)
    } 
    if (action === 'delete') {
      setShowFolderDelete(true);
    }
  }

  function onDeleteFolder(id){
    handleUpdateCategory('delete', id)
    
  }

  function onPageClick(pageUrl) {
    console.log('onPageClick', pageUrl)
    getAssets(null, pageUrl)
  }

  function onAddFolder(){
    setActiveCategory(null) 
    setShowCategoryForm(true)
  }

  function onItemContextMenu(e, id) {
    console.log('onItemContextMenu', e, id)
  }
  
  return (
    <section className="main" id="assetLibrary">
      {showLoader ? (
        <div id="loading">
          <img src={Loader} alt="" />
        </div>
      ) : null}

      {formError && (
        <Modal
          heading={formError.heading}
          text={formError.text}
          onBtn1Click={setFormError}
          onBtn1={null}
          btn1Text={"Close"}
          onBtn2Click={null}
          onBtn2={null}
          btn2Text={null}
        />
      )}

      {showError && (
        <div id="errorPopup">
          <div className="modal">
            <span>
              <h3>Unsaved Changes</h3>
              <p>Are you sure you want to go back?</p>
            </span>{" "}
            <div className="fullRow errorRow">
              <span onClick={() => handleBackBtn("cancel")}>Cancel</span>{" "}
              <span onClick={() => handleBackBtn("force")}>Continue</span>
            </div>
          </div>
        </div>
      )}
      {showFolderDelete && (
        <div id="errorPopup">
          <div className="modal">
            <span>
              <h3>Delete <span className={style.underline} dangerouslySetInnerHTML={{__html: flatCategories.find(a => a.id === activeCategory).text}} /></h3>
              <p>Are you sure?</p>
            </span>{" "}
            <div className="fullRow errorRow">
              <span onClick={() => setShowFolderDelete(false)}>Cancel</span>{" "}
              <span onClick={() => onDeleteFolder(activeCategory)}>Delete</span>
            </div>
          </div>
        </div>
      )}
      {showCategoryForm && (
        <div className="modalContainer">
          <div className="modal">
            <span>
              <h3>{activeCategory ? "Rename Folder" : "New Folder"}</h3>

              <div className="settingsRow">
                <input
                  type="text"
                  autoComplete="off"
                  id="newCategoryName"
                  autoFocus
                  placeholder="Add Folder Name"
                />
              </div>
            </span>{" "}
            <div className="fullRow errorRow">
              <span
                onClick={() => {
                  setShowCategoryForm(false);
                }}
              >
                Cancel
              </span>{" "}
              <span
                onClick={() =>
                 { if (activeCategory) {
                    handleUpdateCategory(
                      'name', document.getElementById("newCategoryName").value
                    )
                  } else {
                    handleAddCategory(
                      document.getElementById("newCategoryName").value
                    )
                  }
                }
                }
              >
                Continue
              </span>
            </div>
          </div>
        </div>
      )}

      {module && (
        <div className="col appGrid">
          <div id="narrativeTools">
           


            <div className="iconField ui" onClick={() => handleAddFile()}>
              <Icons.PhotoAdd
                className="icon ui"
                title="Add File"
                onMouseEnter={(e) => props.onMouseEnter(e, "Add File")}
                onMouseLeave={() => props.onMouseLeave()}
              />
              <input
              type="file"
              style={{ display: "none" }}
              autoComplete="off"
              id={"uploadLibraryAsset"}
              accept={"image/png, image/jpeg, image/webp, video/mp4, video/webm"}
              className={style.inputField}
              onChange={(e) => onUploadAsset(e)}
            />
            </div>
            
            <div
            className="iconField ui"
            onClick={() => onAddFolder()}
          >
            <Icons.AddFolder
            className="icon ui"
            title="Add Category"
            onMouseEnter={(e) => props.onMouseEnter(e, "Add Folder")}
            onMouseLeave={() => props.onMouseLeave()}
          />
        </div>

            <h1>Asset Library</h1>

            <a
              href={
                Config.previewURL +
                "/narrative/" +
                module.narrative +
                "?u=" +
                props.user.link_token +
                "&module=" +
                module.id
              }
              style={{display: "none"}}
              className="previewBtn previewBtnGallery"
              target="_blank"
              rel="noreferrer"
              title="preview"
            >
              <img src={OpenLink} className="icon" alt="" />
            </a>
          </div>
          {props.isModal && <div id="libraryModalHeader" className="flex spaceBetween">
              <h1>Asset Library</h1>
              <Close className="icon ui" onClick={() => props.setShowAssetLibrary(false)} />
          </div>}
          <nav className={classNames("leftNav", style.assetLeftNav)}>
            <span id="libraryLeftArrow">
              <div
              className="leftArrow iconField"
              onClick={() => handleBackBtn()}
              >
              <ArrowBack className="icon" />

              <div className="pages">Spaces Overview</div>
            </div></span>

            <span className="pages modulePages">
              <div className="sectionRows">
                <div className="layerToggle">
                  <span className={`layerToggleBtn on`}>Assets</span>
                </div>

                <div className={classNames(style.menuBtn, 'iconField', !activeCategory && "pageOn")} onClick={() => setActiveCategory(null)}><AllPhotos className="icon" /> All Files</div>

                {categories && (
                  <div className={"sortableBox"}>
                   
                    <SortableTree
                      defaultItems={categories}
                      indicator
                      collapsible
                      category={'folders'}
                      activationConstraint={{
                        delay: 200,
                        tolerance: 15,
                      }}
                      activePageId={activeCategory}
                      // Functions
                      // setEditPageForm={props.setEditPageForm} //this is for delete only
                      onMenuSort={onMenuSort}
                      onItemClick={onLayerClick}
                      onItemContextMenu={onItemContextMenu}
                      isDragActive={props.isModal ? false : true}
                      allowNesting={true}
                    />
                  </div>
                )}
              </div>
            </span>
           {storage &&  <span className={style.storage}>
                <span className="flex spaceBetween">
                  <span>Storage</span>
                  <span>{storage.storage_available.toFixed(2)} GB available</span>
                </span>
                <span className={style.progressBar}>
                <svg xmlns="http://www.w3.org/2000/svg" width="251" height="4" viewBox="0 0 251 4" fill="none">
                  <rect width="251" height="4" rx="2" fill="#555555"/>
                  <rect ref={storageBarRef} width="0" height="4" rx="2" fill="#007AFF"/>
                  </svg>
                </span>
                
            </span>}
          </nav>
          <div className="core">
          <div className={classNames(style.headingRow)}>
              <span className={style.heading}>
              {!activeCategory && <h2>All Files</h2>}
              {activeCategory && <h2><span dangerouslySetInnerHTML={{__html: flatCategories.find(a => a.id === activeCategory).text}}></span></h2>}
              {activeCategory ? module.length : pages && pages.count} {(activeCategory ? module.length === 1 : pages && pages.count === 1) ? "File" : "Files"}
   
              {activeCategory && <span>
                <Icons.Ellipses className="icon ui" onClick={() => onUpdateFolderBtn()} />
                <span className={'smModal'} id="updateFolderModal">
                 
                    <span className={'smModalChoice ui'} onClick={() => onUpdateFolder('rename')}><Icons.Pencil className="icon ui" /> Rename</span>
                    <span className={'smModalChoice ui'} onClick={() => onUpdateFolder('delete')}><Icons.Delete className="icon ui" />Delete</span>
                </span>
              </span>}
              
                </span>
              <span className={classNames(style.filters, 'flex', 'alignCenter', 'ui')}>
                <span id="settingsRow_sorting">
                <span className="iconField" onClick={() => onSortBtn()}><Icons.Filter className={classNames("icon", ['created', '-name'].includes(sort) && style.flip)} /> {sorting.find(a => a.value === sort).label}</span>
                <span className={'smModal'} id="sortModal">
                  {sorting.map((obj, i) => (
                    <span key={'choices'+i} className={'smModalChoice'} onClick={() => onSortChoice(obj.value)}>{obj.label}</span>
                  ))}
                </span>
                
              </span>
                
                
                <span><input type="search" placeholder="Search" className={style.inputField} onChange={(e) => clearSearch(e)}  onKeyUp={(e) => onSearch(e)} /></span>
              </span>
          </div>
          <div ref={thumbsRef} className="flex flexColumn gap30">
            <div className={classNames("grid", "grid4", style.thumbs)}>
                  
                  {pages && !pages.previous && categories && !activeCategory && categories.map((obj, i) => (
                    <span key={'file_' + i} onClick={() => setActiveCategory(obj.id)} className={classNames(style.thumbBox, style.folderBox, "ui")}>
                      <span className={style.thumb}>
                        <Icons.Folder className="icon" />
                      </span>
                      <span className={classNames("iconField", style.fileName)}>{stripTags(obj.text)}</span>
                    </span>
                  ))}

              

                  {flatCategories && activeCategory && flatCategories.filter(a => a.parent === activeCategory).map((obj, i) => (
                    <span key={'file_' + i} onClick={() => setActiveCategory(obj.id)} className={classNames(style.thumbBox, style.folderBox, 'ui')}>
                      <span className={style.thumb}>
                        <Icons.Folder className="icon" />
                      </span>
                      <span className={classNames("iconField", style.fileName)}>{stripTags(obj.text)}</span>
                    </span>
                  ))}
              </div>
              <div className={classNames("grid", "grid4", style.thumbs)}>
                

                  {module && module.map((obj, i) => (
                    <span key={'file_' + i} className={classNames(style.thumbBox, 'ui', (selectFile === obj.id) && style.selected)} onClick={() => onFileClick(obj)}>
                      <span className={style.thumb}>
                        {obj.file_thumb && <img src={Config.mediaURL + obj.file_thumb + '?v=' + obj.modified} alt="thumb" />}
                        {!obj.file_thumb && obj.file_type === 'svg' && obj.file_original && <img src={Config.mediaURL + obj.file_original + '?v=' + obj.modified} alt="thumb" />}
                        
                      </span>
                      <span className={classNames("iconField", style.fileName)}>{fileNameType(obj.file || obj.file_original || obj.name, obj.name).map((obj2, j) => (<span key={"fileName_" + j}>{obj2}</span>))}</span>

                    </span>
                  ))}
                  
              

              </div>
            </div>
              <div className={classNames(
                "flex",
                "spaceBetween",
                style.pages
              )}>
                {pages && pages.previous && <div className={classNames(
                  "prevPage", 
                  "iconField", 
                  "ui"
                  )} onClick={() => onPageClick(pages.previous)}><ArrowBack className="icon" />Previous</div>}

                {pages && pages.next && <div className={classNames(
                  "nextPage", 
                  "iconField", 
                  "ui"
                  )} onClick={() => onPageClick(pages.next)}>Next<ArrowBack className="icon flip" /></div>}
            
              </div>
          </div>
        </div>
      )}

      {moduleObj && files.filter(a => a.id === moduleObj).map((obj , i) => 
        
        <div className="moduleDetail" id={"moduleDetail_" + obj.id} key={i + 'module'}>
          <div className="moduleContainer">
            <div
              className="closeModal ui"
              onClick={() => {
                animModalOut(obj.id, obj.file);
              }}
            >
              <Close className="icon" />
            </div>
        
            <span className="file">
              {obj.file && getFileType(obj.file) === "img" && (
                <span className="fileImage">
                  <img
                    src={Config.mediaURL + obj.file + '?v=' + obj.modified}
                    alt=""
                    onClick={() =>
                      document
                        .getElementById("inputField_file_" + obj.id)
                        .click()
                    }
                  />
                </span>
              )}

              {!obj.file && obj.file_type === 'svg' && obj.file_original && (
                <span className="fileImage">
                  <img
                    src={Config.mediaURL + obj.file_original + '?v=' + obj.modified}
                    alt=""
                  />
                </span>
              )}

              {obj.file_original && getFileType(obj.file_original) === "vid" && (
                <span className="fileVideo">
                  <video key={obj.file_original + obj.modified} width="320" height="240" controls>
                    <source
                      src={Config.mediaURL + obj.file_original + '?v=' + obj.modified}
                      type="video/mp4"
                    />
                  </video>
                </span>
              )}

              <input
                type="file"
                style={{ display: "none" }}
                autoComplete="off"
                id={"inputField_file_" + obj.id}
                accept={obj.file_type === 'svg' ? "image/svg+xml" : "image/png, image/jpeg, image/webp, video/mp4, video/webm"}
                className={style.inputField}
                onChange={(e) => handleModuleMedia(e, "file_original")}
              />
            </span>

            <div className="moduleSettings">
              <div className="groupLabel">
                <p>File Settings</p>
              </div>
              <div className="row flex flexColumn gap10" id="settingsRow_fileType">
                <span className="flex flexColumn gap0">
                <span className="groupLabel alignCenter flex">
                <span>FILE</span>
                {obj.file_original ? <span onClick={() => downloadFile(obj.file_original)}><Icons.Download className="icon ui" /></span> : <span onClick={() => downloadFile(obj.file_original)}><Icons.Download className="icon ui" /></span>}
                </span>
                <span className={classNames("flex", "gap10", "alignCenter", style.library)}>
               
                 <span className={classNames(style.fileInput)}>
                {(editField === "name") ? 
                  <span className="inputField ui">
                    <input className={style.inputField} onKeyUp={(e) => handleOnKeyUp(e, "name", 'asset')} onBlur={(e) => handleModuleSave("name", e.target.value)} type="text" autoComplete="off" defaultValue={obj.name ? obj.name : (obj.file ? obj.file.replace('library/','') : '')} name="layer_name" id="layer_name" />
                </span> :
                <div className="iconField fieldValue">{fileNameType(obj.file || obj.file_original || obj.name, obj.name).map((obj2, j) => (<span key={"fileName_" + j}>{obj2}</span>))}</div>
                }

                </span>
                  {(editField === "name") ? <span className="smCancel ui" onClick={() => setEditField(null)}><Icons.Cancel/></span> : <Icons.Pencil className="icon ui" onClick={() => setEditField("name")} />}
                
                 
                  </span>
                </span>

                <span className="grid grid2 alignCenter">
                  <span className="canvasLabel">File Type</span>
                  <span>{(obj.file || obj.file_original) ? (obj.file || obj.file_original).split('.').pop().toUpperCase() : '—'}</span>
                </span>
                <span className="grid grid2 alignCenter">
                  <span className="canvasLabel">Dimensions</span>
                  <span>{obj.width} x {obj.height}</span>
                </span>
                {obj.size ? <span className="grid grid2 alignCenter">
                  <span className="canvasLabel">Size</span>
                  <span>{Math.round(obj.size/1024)} KB</span>
                </span> :
                <span className="grid grid2 alignCenter">
                  <span className="canvasLabel">Size</span>
                  <span>{Math.round(obj.size_original/1024/1024)} MB</span>
                </span>}
                <span className="grid grid2 alignCenter">
                  <span className="canvasLabel">Added</span>
                  <span>{format(new Date(zonedTimeToUtc(obj.created, Intl.DateTimeFormat().resolvedOptions().timeZone)), "MMM d, Y")}</span>
                </span>

                <div className="row settingsGridFull" id="settingsRow_category">
                <div className="canvasLabel">Folder</div>

                 <Dropdown key={obj.modified} selectionField={'text'} selection={obj.folder} choices={categories} id={obj.id} name="category" onSelection={onSelectFolder} />
              </div>
              
              </div>

              <div className="settingsRow">
                <div
                  className="moduleHeading"
                  id={"inputField_thumbnail" + obj.id}
                >
               
                  <div className="fieldRow">
                    {obj.file_original && (
                        <div
                          className="ui btn1 autoWidth"
                          onClick={() =>
                            document
                              .getElementById("inputField_file_" + obj.id)
                              .click()
                          }
                        >
                          Replace {obj.file_type === 'svg' ? "SVG" : getFileType(obj.file_original) === "vid" ? "Video" : "Image"}
                        </div>
                      )}
                  </div>
                </div>

                <div className="settingsRow deleteRow">
                  <div
                    className="iconField ui"
                    onMouseEnter={(e) =>
                      props.onMouseEnter(e, "Double click to delete")
                    }
                    onMouseLeave={() => props.onMouseLeave()}
                    onDoubleClick={() => handleModuleSave("delete", true)}
                  >
                    <Delete className="icon" />{" "}
                    <div className="canvasLabel">Delete File</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        
        </div>
      )}
      {selectFile && <span onClick={() => props.addAsset(selectFile, props.showAssetLibrary)} className={classNames(style.addAssetRow, 'ui')}>Add Asset</span>}
    </section>
  );
}

export default Library;
// .filter(a => (a.folder === activeCategory || a.folder === null))